import React from 'react'
import Modal from '../../component/Inc/Modal'
function PopPolicyPoint(props) {
  const {open, close} = props
  return (
    <Modal open={open} close={close} type="pop_point">
      <h2 className="pop_tit">+ 직급 가점 정책</h2>
      <p className="pop_desc">직급가점 운영표를 다음과 같이 공지드립니다.</p>
      <div className="content_container scroll">
        <table className="com_board_list type_bg_blue">
          <colgroup>
            <col width="70" />
            <col width="100" />
            <col width="200" />
            <col width="50" />
            <col width="50" />
            <col width="50" />
            <col width="50" />
            <col width="100" />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan={2}>분류</th>
              <th rowSpan={2}>항목</th>
              <th rowSpan={2}>내용</th>
              <th colSpan={4}>직급가점</th>
              <th rowSpan={2}>비고</th>
            </tr>
            <tr>
              <th>조건</th>
              <th>점수</th>
              <th>분가상한</th>
              <th>최소조건</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="bg_col">강사소개</td>
              <td>강사소개</td>
              <td>소개한 강사가 계약 후 1타임 이상 배정 후 실제 수업 진행시 (단, 첫수업 실패시 제외)</td>
              <td>1명</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>23년 소개 건 소급</td>
            </tr>
            <tr>
              <td rowSpan={3} className="bg_col">
                교관
              </td>
              <td>교관(신규교육)</td>
              <td>신규강사 교육 교관 활동</td>
              <td>1시간</td>
              <td>0.5</td>
              <td rowSpan={3}>4</td>
              <td>3시간 이상</td>
              <td></td>
            </tr>
            <tr>
              <td>교관(특별교육)</td>
              <td>특별 교육(핵심강사, 리스타트 등)교관 활동</td>
              <td>1시간</td>
              <td>0.5</td>
              <td>3시간 이상</td>
              <td></td>
            </tr>
            <tr>
              <td>멘토링</td>
              <td>신규강사 교육 교관 활동</td>
              <td>1시간</td>
              <td>0.5</td>
              <td>3시간 이상</td>
              <td></td>
            </tr>
            <tr>
              <td className="bg_col">교육</td>
              <td>교육수료</td>
              <td>교육과정 수료</td>
              <td>1-2</td>
              <td>3</td>
              <td></td>
              <td></td>
              <td>개별 기안 후 사전 공지</td>
            </tr>
            <tr>
              <td rowSpan={3} className="bg_col">
                교재
              </td>
            </tr>
            <tr>
              <td>기획위 </td>
              <td>기능팀 성과회의 과제 또는 발표 수행자(연2-3회)</td>
              <td>1회</td>
              <td>1</td>
              <td rowSpan={2}>8(연간)</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>기능팀 </td>
              <td>기능팀 활동(참여도 70%이상)또는 신규교재 개발 활동(주된 참여))</td>
              <td>연간</td>
              <td>1-8</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td className="bg_col">영상</td>
              <td>영상제작(1차)</td>
              <td>학습관리시스템 동영상강의 1차분 촬영 참여</td>
              <td>1강당</td>
              <td>0.1</td>
              <td>4</td>
              <td>5강 이상</td>
              <td>1차분만 한시 적용</td>
            </tr>
            <tr>
              <td className="bg_col">기타</td>
              <td>기타</td>
              <td>프로젝트의 과제, 발표 등 과업 수행, 비정기적.불시 진행되는 행사 등</td>
              <td>프로젝트당</td>
              <td>0.5-2</td>
              <td>3</td>
              <td></td>
              <td>개별 기안 후 사전 공지</td>
            </tr>
            <tr>
              <td rowSpan={6} className="bg_col">
                교관
              </td>
              <td>수업다수</td>
              <td>다수 수업 진행 교사</td>
              <td>120회당</td>
              <td>1</td>
              <td>8(연간)</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>수2 자격증</td>
              <td>수2 자격증 취득</td>
              <td></td>
              <td>1</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td rowSpan={2}> 실적우수 강사</td>
              <td>분기종합실적 1위(과목별)</td>
              <td>분기당</td>
              <td>1</td>
              <td>1</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>최다 이달의 우수교사(과목별)</td>
              <td>연간</td>
              <td>1</td>
              <td>1(연간)</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>최우수 신규강사</td>
              <td>전임화 2단계 달성</td>
              <td></td>
              <td>1</td>
              <td rowSpan={2}>2</td>
              <td></td>
              <td>23년 신규강당 소급</td>
            </tr>
            <tr>
              <td>우수 신규강사</td>
              <td>전임화 1단계 달성</td>
              <td></td>
              <td>1</td>
              <td></td>
              <td>23년 신규강당 소급</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button onClick={close} className="com_btn orange xs">
          확인
        </button>
      </div>
    </Modal>
  )
}

export default PopPolicyPoint
